<template>
  <div>
    <button class="button-export" @click="exportSafeguards($event)">
      Export
      <span>Spreadsheet</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CIS-Controls-Navigator-Export',
  emits: ['exportSafeguards'],
  methods: {
    exportSafeguards(event) {
      event.target.disabled = true;
      event.target.classList.add('disabled');
      const enableButton = () => {
        event.target.disabled = false;
        event.target.classList.remove('disabled');
      };
      const onDone = (d) => {
        enableButton();
      };
      const onError = (error) => {
        enableButton();
        alert(`Unable to export spreadsheet: ${error}`);
      };
      this.$emit('exportSafeguards', onDone, onError);
    }
  }
};
</script>
<style lang="scss" scoped>
.button-export {
  background-color: $orange;
  -webkit-transition: background-color 300ms ease;
  -ms-transition: background-color 300ms ease;
  transition: background-color 300ms ease;
  border: 1.5px solid $orange;
  border-radius: 4px;
  padding: 1.3rem 5.2rem 1.3rem 2.4rem;
  @include font-styles('Arial Narrow', 1.8rem, 500, normal, 2.2rem, 0, $white);
  text-transform: uppercase;
  margin-bottom: 2rem;
  white-space: nowrap;

  @include tablet-up {
    margin-left: 3rem;
    margin-bottom: 0;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 2.5rem;
    background-image: url(~@/assets/images/icon-export.svg);
    background-repeat: no-repeat;
    background-size: contain;
    width: 1.8rem;
    height: 1.9rem;
    transform: translate(0, -50%);
  }

  &.disabled {
    background-color: rgba($orange, 0.75);
    cursor: not-allowed;
  }
}
</style>
